import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'

import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GeneratePin = async (msisdn, clientId, clientSecret, customHeaders = {}, utilities = {}) => {

  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  const requestBody = {
    'name': 'Generate Pin',
    'desc': 'Generate Pin',
    'type': 'pin',
    'category': [
      {
        'value': 'pin',
        'listHierarchyId': 'Vodafone'
      }
    ],
    'details': {
      'lifespan': {
        'value': '',
        'unitCode': ''
      },
      'requestType': 'pin'
    },
    'roles': {
      'requestor': {
        'id': [
          {
            'value': msisdn,
            'schemeName': 'Requestor ID',
            'schemeAgencyName': 'Vodafone'
          }
        ],
        'name': 'Xhulio',
        'desc': '',
        'type': '',
        'category': [
          {
            'value': '',
            'listHierarchyId': 'Vodafone'
          }
        ],
        'status': ''
      }
    },
    'parts': {
      'specification': {
        'id': [
          {
            'schemeAgencyName': 'Vodafone',
            'schemeName': 'Specification ID',
            'value': '123'
          }
        ],
        'name': 'Consumer Change Authentication Credential',
        'desc': 'Consumer Change Authentication Credential',
        'type': 'token',
        'category': [
          {
            'listHierarchyId': '1',
            'value': 'token'
          }
        ],
        'characteristicsValue': [
          {
            'characteristicName': 'client_id',
            'value': clientId,
            'creationTime': {
              'value': ''
            },
            'validityPeriod': {
              'fromDate': {
                'date': ''
              },
              'toDate': {
                'date': ''
              }
            }
          },
          {
            'characteristicName': 'client_secret',
            'value': clientSecret,
            'creationTime': {
              'value': ''
            },
            'validityPeriod': {
              'fromDate': {
                'date': ''
              },
              'toDate': {
                'date': ''
              }
            }
          }
        ]
      }
    }
  }

  const data = {
    data: requestBody
  }

  onStart()

  try {
    const response = await axios.post(API_URLS.baseUrlDXL + API_URLS.generatePin, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const ValidatePin = async (pinCode, msisdn, clientId, clientSecret, customHeaders = {}, utilities = {}) => {
  const _utilities = retrieveUtilities(utilities)

  const {
    onStart,
    onSuccess,
    onError,
    responseMapper,
    errorMapper
  } = _utilities

  const requestBody = {
    'id': [{
      'value': pinCode,
      'schemeAgencyName': 'Vodafone',
      'schemeName': 'Security Token ID'
    }
    ],
    'name': 'Validate Pin',
    'desc': 'Validate Pin',
    'type': 'pin',
    'category': [{
      'value': 'pin',
      'listHierarchyId': 'Vodafone'
    }
    ],
    'details': {
      'lifespan': {
        'value': '',
        'unitCode': ''
      },
      'requestType': 'pin'
    },
    'roles': {
      'requestor': {
        'id': [{
          'value': msisdn,
          'schemeName': 'Requestor ID',
          'schemeAgencyName': 'Vodafone'
        }
        ],
        'name': 'Xhulio',
        'desc': '',
        'type': '',
        'category': [{
          'value': '',
          'listHierarchyId': 'Vodafone'
        }
        ],
        'status': ''
      }
    },
    'parts': {
      'specification': {
        'id': [
          {
            'schemeAgencyName': 'Vodafone',
            'schemeName': 'Specification ID',
            'value': '123'
          }
        ],
        'name': 'Consumer Change Authentication Credential',
        'desc': 'Consumer Change Authentication Credential',
        'type': 'token',
        'category': [
          {
            'listHierarchyId': '1',
            'value': 'token'
          }
        ],
        'characteristicsValue': [
          {
            'characteristicName': 'client_id',
            'value': clientId,
            'creationTime': {
              'value': '2015-04-01T00:00:00'
            },
            'validityPeriod': {
              'fromDate': {
                'date': '2015-04-01'
              },
              'toDate': {
                'date': '2015-04-01'
              }
            }
          },
          {
            'characteristicName': 'client_secret',
            'value': clientSecret,
            'creationTime': {
              'value': '2015-04-01T00:00:00'
            },
            'validityPeriod': {
              'fromDate': {
                'date': '2015-04-01'
              },
              'toDate': {
                'date': '2015-04-01'
              }
            }
          }
        ]
      }
    }
  }

  const data = {
    data: requestBody
  }

  onStart()

  try {
    const response = await axios.post(API_URLS.baseUrlDXL + API_URLS.validatePin + pinCode, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

export { GeneratePin, ValidatePin }
